export function playAlarmBeep({
  frequency = 880,
  pulseSec = 0.15,
  intervalMs = 400,
} = {}) {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return () => {};

    const ctx = new Ctx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.value = frequency;
    gain.gain.value = 0.15;
    osc.start();

    const interval = setInterval(() => {
      if (ctx.state === 'closed') return;
      gain.gain.setValueAtTime(0.15, ctx.currentTime);
      gain.gain.setValueAtTime(0, ctx.currentTime + pulseSec);
    }, intervalMs);

    let stopped = false;
    return () => {
      if (stopped) return;
      stopped = true;
      clearInterval(interval);
      try {
        osc.stop();
      } catch {
        // already stopped
      }
      try {
        if (ctx.state === 'running' || ctx.state === 'suspended') {
          const closing = ctx.close();
          if (closing && typeof closing.catch === 'function') {
            closing.catch(() => {});
          }
        }
      } catch {
        // already closed
      }
    };
  } catch {
    return () => {};
  }
}
